import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    options: Array,
    disableSearch: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    removableOption: { type: Boolean, default: true },
    flags: { type: Boolean, default: false },
  };

  connect() {
    if (!this.element.tomselect) {
      (() => new TomSelect(this.element, this._settingsFactory(this.element)))();
    }
  }

  disconnect() {
    const value = this.element.value;
    this.element.tomselect.destroy();
    this.element.value = value;
  }

  _settingsFactory(element) {
    const ajaxUrl = element.dataset.ajaxUrl;
    const ajaxTextField = element.dataset.ajaxTextField;
    const ajaxValueField = element.dataset.ajaxValueField;
    const ajaxMatcher = element.dataset.ajaxSearchMatcher;
    const ajaxDisplayedField = (
      element.dataset.ajaxDisplayedField ? element.dataset.ajaxDisplayedField : ajaxTextField
    );
    const ajaxAdditionalFilters = (
      element.dataset.ajaxAdditionalFilters
        ? JSON.parse(element.dataset.ajaxAdditionalFilters)
        : []
    );

    const additionalFiltersQuery = ajaxAdditionalFilters.reduce((acc, filter) => {
      return acc + `&q[${filter[0]}]=${filter[1]}`;
    }, '');

    const formatAjaxData = (json, valueField, textField) => {
      return json.map(entry => ({
        value: entry[valueField],
        text: entry[textField]
      }));
    };

    const settingsStore = {
      create: {
        create: input => ({ value: '', text: input }),
        persist: false
      },
      ajax: {
        valueField: 'value',
        labelField: 'text',
        searchField: 'text',
        load: function (query, callback) {
          const url = `${ajaxUrl}?q[${ajaxTextField}_${ajaxMatcher}]=${encodeURIComponent(query)}${additionalFiltersQuery}`;
          fetch(url, {
            headers: { Accept: 'application/json' }
          })
            .then(response => response.json())
            .then(json => {
              callback(formatAjaxData(json, ajaxValueField, ajaxDisplayedField));
            }).catch((e) => {
              callback();
            });
        }
      }
    };

    const placeholder = this.placeholderValue || '';

    const settings = {
      placeholder: placeholder,
      maxOptions: null,
      onItemAdd: function () { this.setTextboxValue(''); },
      plugins: this.removableOptionValue ? { remove_button: { title: 'remove' } } : {},
    };

    if (this.disableSearchValue) {
      settings.controlInput = null;
      delete settings.plugins.remove_button;
    }

    if (this.flagsValue) {
      settings.render = {
        option: (data, escape) => this.#renderCountryFlag(data, escape),
        item: (data, escape) => this.#renderCountryFlag(data, escape),
      };
    }

    if (this.hasOptionsValue) { Object.assign(settings, settings, { options: this.optionsValue }); }
    if (element.classList.contains('tom-select-ajax')) { Object.assign(settings, settings, settingsStore.ajax); }
    if (element.classList.contains('tom-select-create')) { Object.assign(settings, settings, settingsStore.create); }

    return settings;
  }

  // The option value is the ISO 3166-1 alpha-2 country code (e.g. "FR"), which maps
  // to a flag-icons class (e.g. "fi-fr"). The blank option has no value, so no flag.
  #renderCountryFlag(data, escape) {
    if (!data.value) {
      return `<div>${escape(data.text)}</div>`;
    }

    const countryCode = escape(data.value.toLowerCase());

    return '<div class="d-flex align-items-center gap-2">' +
      `<span class="fi fi-${countryCode}" aria-hidden="true"></span>` +
      `<span>${escape(data.text)}</span></div>`;
  }
}
